const selects = [...document.querySelectorAll('form select')];
const textareas = [...document.querySelectorAll('textarea')];
const selectedClass = 'form-select--selected';

export const updatePlaceholder = (input) => {
  const emptyOptions = ['', 'All'];
  if (!emptyOptions.includes(input.options[input.selectedIndex].value)) {
    input.classList.add(selectedClass);
  } else {
    input.classList.remove(selectedClass);
  }
};

export const moveTheLabel = (element) => {
  const wrapper = element.parentNode;
  if (wrapper.nextElementSibling) {
    wrapper.appendChild(wrapper.nextElementSibling);
  }
};

export const updateSelects = (items) => {
  items.forEach((select) => {
    moveTheLabel(select);

    select.addEventListener('change', ({ target }) => {
      updatePlaceholder(target);
    });

    // Trigger the change event on load when having value.
    // For example in: views.
    if (select.selectedIndex !== -1) {
      select.dispatchEvent(new Event('change'));
    }
  });
};

export const updateTextareas = (items) => {
  items.forEach((textarea) => moveTheLabel(textarea));
};

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    const form = mutation.target;
    [...form.querySelectorAll('select')].forEach((select) => {
      moveTheLabel(select);
      select.addEventListener('change', ({ target }) => {
        updatePlaceholder(target);
      });
    });
    [...form.querySelectorAll('textarea')].forEach((textarea) =>
      moveTheLabel(textarea),
    );

    // @todo we need to use AutoHeight but we cant reInit to recalculate the height of the panels.
    // const parentViewport = form.closest('.tabs__panels-viewport');
    // if (parentViewport) {
    //   console.log(EmblaCarousel(parentViewport).internalEngine());
    // }
  });
});

// configuration of the observer:
const config = {
  childList: true,
  characterData: false,
};

(() => {
  if (selects.length) {
    updateSelects(selects);
  }

  if (textareas.length) {
    updateTextareas(textareas);
  }
})();

document.addEventListener('DOMContentLoaded', () =>
  document
    .querySelectorAll('.webform-ajax-form-wrapper')
    .forEach((webform) => observer.observe(webform, config)),
);
